import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import multiMonthPlugin from '@fullcalendar/multimonth'
import {ICalendarProps} from './interfaces'
import Loading from '../../modules/loading'
import {useRef, useState} from 'react'
import {handleDayCellDidMount} from './utils'

const Calendar = ({
  calendarRef,
  headerToolbar = false,
  nowIndicator = true,
  className = '',
  viewClassNames,
  views,
  events,
  eventContent,
  height = 'auto',
  plugins = {
    isDayGridPlugin: true,
    isInteractionPlugin: true,
    isMultiMonthPlugin: false,
  },
  dayCellDidMount: externalDayCellDidMount,
  isLoading = false,
  onAddEvent,
  isReadOnly = false,
  // Drag and drop props
  isDraggable = false,
  eventDrop,
  eventResize,
  eventReceive,
  eventDragStart,
  eventDragStop,
}: ICalendarProps) => {
  const calendarContainerRef = useRef<HTMLDivElement>(null)
  const [hoveredDate, setHoveredDate] = useState<Record<string, any> | null>(null)
  const [hoverPosition, setHoverPosition] = useState({x: 0, y: 0})

  const pluginsList = [
    ...(plugins.isInteractionPlugin ? [interactionPlugin] : []),
    ...(plugins.isMultiMonthPlugin ? [multiMonthPlugin] : []),
    ...(plugins.isDayGridPlugin ? [dayGridPlugin] : []),
  ]

  const onDayCellDidMount = (info: any) => {
    externalDayCellDidMount?.(info)
    if (isReadOnly) return
    handleDayCellDidMount(info, setHoveredDate, setHoverPosition, calendarContainerRef)
  }

  return (
    <div ref={calendarContainerRef} className={`min-h-300px position-relative ${className}`}>
      {isLoading && <Loading />}
      <FullCalendar
        ref={calendarRef}
        plugins={pluginsList}
        headerToolbar={headerToolbar}
        nowIndicator={nowIndicator}
        viewClassNames={viewClassNames}
        views={views}
        events={events}
        eventContent={eventContent}
        height={height}
        dayCellDidMount={onDayCellDidMount}
        editable={isDraggable && !isReadOnly}
        droppable={isDraggable && !isReadOnly}
        eventDrop={eventDrop}
        eventResize={eventResize}
        eventReceive={eventReceive}
        eventDragStart={eventDragStart}
        eventDragStop={eventDragStop}
      />

      {hoveredDate && !isReadOnly && onAddEvent && (
        <button
          onClick={() => onAddEvent?.(hoveredDate)}
          className='btn bg-white border border-2 border-primary rounded-circle z-index-1 w-30px h-30px position-absolute 
            d-flex align-items-center justify-content-center 
            floating-plus-icon'
          style={{
            left: hoverPosition.x,
            top: hoverPosition.y,
          }}
        >
          <i className='fas fa-plus fs-6 p-1 text-primary' />
        </button>
      )}
    </div>
  )
}

export default Calendar
